var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var StyledDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  display: inline-flex;\n  cursor: pointer;\n  width: 100%;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  border-radius: 4px;\n  span {\n    margin: 5px;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 150%;\n    letter-spacing: -0.011em;\n    color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  display: inline-flex;\n  cursor: pointer;\n  width: 100%;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  border-radius: 4px;\n  span {\n    margin: 5px;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 150%;\n    letter-spacing: -0.011em;\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.coral.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.alerta.bold;
});
export var ErrorMessage = function (_a) {
    var onErrorMessageClick = _a.onErrorMessageClick, children = _a.children;
    return (React.createElement(StyledDiv, { onClick: onErrorMessageClick },
        React.createElement("span", null, children)));
};
var templateObject_1;
